import { render, staticRenderFns } from "./directoryDetail.vue?vue&type=template&id=0748bc06&scoped=true&lang=html&"
import script from "./directoryDetail.vue?vue&type=script&lang=js&"
export * from "./directoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./directoryDetail.vue?vue&type=style&index=0&id=0748bc06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0748bc06",
  null
  
)

export default component.exports